import PropTypes from "prop-types";
import React from 'react'


const SEO = ( {title, description} ) => {
    return (
        <>
            <meta charSet="utf-8" />
            <title>{title + " || Pizzi Web Solutions"}</title>
            <meta name="description" content={`${description} Milano, Como, Varese, Monza e Brianza – Pizzi Web Solutions`} />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;


